import { defineMessages } from 'react-intl';
import { ADVISOR_CONNECTION_STATUSES } from 'store/features/company-advisor-connections/helpers';
import { fieldNames } from './model';

export const connectionStatuses = defineMessages({
  [ADVISOR_CONNECTION_STATUSES.pendingSignUpByUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-sign-up',
    defaultMessage: 'Pending Signup',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingEthAddressFromUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-eth-address',
    defaultMessage: 'Pending Eth Address',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByUser]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-user',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-company',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.pendingTransactionSigningByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.pending-transaction-signing-by-both',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.signedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.signed',
    defaultMessage: 'Verified',
  },
  [ADVISOR_CONNECTION_STATUSES.rejectedByUser]: {
    id: 'admin.companies.advisors.connections.statuses.rejected',
    defaultMessage: 'Rejected',
  },
  [ADVISOR_CONNECTION_STATUSES.unknown]: {
    id: 'admin.companies.advisors.connections.statuses.unknown',
    defaultMessage: 'Unknown',
  },

  [ADVISOR_CONNECTION_STATUSES.softStatusPendingAtUser]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusPendingAtUser',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusPendingValidationByUser]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusPendingValidationByUser',
    defaultMessage: 'Pending',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusPendingApprovalByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusPendingApprovalByCompany',
    defaultMessage: 'Pending Admin Approval',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusDisapprovedByCompany]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusDisapprovedByCompany',
    defaultMessage: 'Rejected',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusAcceptedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusAcceptedByBoth',
    defaultMessage: 'Accepted',
  },
  [ADVISOR_CONNECTION_STATUSES.softStatusRejectionConfirmedByBoth]: {
    id: 'admin.companies.advisors.connections.statuses.softStatusRejectionConfirmedByBoth',
    defaultMessage: 'Rejected',
  },
});

export const connectionActions = defineMessages({
  confirmRevoke: {
    id: 'admin.companies.advisors.connections.invitation.revoke',
    defaultMessage: `<p class="lead">Are you sure you want to revoke advisor connection to <strong>{companyName}</strong>?</p>`,
  },
  revoked: {
    id: 'admin.companies.advisors.connections.invitation.revoked',
    defaultMessage: `You are no longer an advisor for {companyName}`,
  },
  confirmReject: {
    id: 'admin.companies.advisors.connections.invitation.reject',
    defaultMessage: `<p class="lead">Are you sure you want to reject advisor invitation from <strong>{companyName}</strong>?</p>`,
  },
  rejected: {
    id: 'admin.companies.advisors.connections.invitation.rejected',
    defaultMessage: `You have rejected an advisor connection request from {companyName}`,
  },
});

export const softConnection = defineMessages({
  confirmationTitle: {
    id: 'advisors.connections.invitation.confirmationTItle',
    defaultMessage: `Advisor confirmation`,
  },
  confirmationSubtitle: {
    id: 'advisors.connections.invitation.confirmationSubtitle',
    defaultMessage: "Please confirm if you're an advisor for <b>{companyName}</b>",
  },
  confirmAccept: {
    id: 'advisors.connections.invitation.accept',
    defaultMessage: `Are you sure you want to accept advisor invitation from <strong>{companyName}</strong>?`,
  },
  confirmReject: {
    id: 'advisors.connections.invitation.reject',
    defaultMessage: `Are you sure you want to reject advisor invitation from <strong>{companyName}</strong>?`,
  },
  acceptSuccessTitle: {
    id: 'advisors.connections.invitation.accept.success',
    defaultMessage: "You've accepted an advisor position at <b>{companyName}</b>",
  },
  rejectSuccessTitle: {
    id: 'advisors.connections.invitation.reject.success',
    defaultMessage: `You've rejected an advisor position at <b>{companyName}</b>`,
  },
  pleaseValidate: {
    id: 'advisors.connections.invitation.validate',
    defaultMessage: `Please login with LinkedIn to confirm`,
  },
  validateSucess: {
    id: 'advisors.connections.invitation.validateSuccess',
    defaultMessage: `Thank you for your confirmation`,
  },
  validateSucessSubtitle: {
    id: 'advisors.connections.invitation.validateSuccessSubtitle',
    defaultMessage: `You can now continue to your profile`,
  },
  noValidConnectionFound: {
    id: 'advisors.connections.invitation.noValidConnection',
    defaultMessage: 'No valid connection request found.',
  },
});

export const softConnectionActions = defineMessages({
  confitmationYes: {
    id: 'advisors.connections.invitation.confirmationYes',
    defaultMessage: `Yes, I am`,
  },
  confitmationNo: {
    id: 'advisors.connections.invitation.confirmationNo',
    defaultMessage: `No, I am not`,
  },
  continue: {
    id: 'advisors.connections.invitation.continue',
    defaultMessage: `Continue`,
  },
  change: {
    id: 'advisors.connections.invitation.change',
    defaultMessage: `Change`,
  },
});

export const labels = defineMessages({
  [fieldNames.acceptTermsAndConditions]: {
    id: `auth.sign-up.fields.acceptTermsAndCondition.label`,
    defaultMessage:
      'By checking this box, I confirm that I have read and agree to the {terms} and {privacy}.',
  },
});



// WEBPACK FOOTER //
// ./src/ui/users/advisories/messages.js